import Section from "@/components/Section";
import { Box, Typography, useTheme } from "@mui/material";
import { useRef } from "react";
import { animated, useScroll, useSpring } from "react-spring";
import BenefitItem from "./components/BenefitItem";
import { options } from "./mockData";

const BenefitsSection = () => {
  const theme = useTheme();
  const ref = useRef<HTMLDivElement>(null);
  const [style, set] = useSpring(() => ({
    offset: 0,
  }));

  useScroll({
    onChange: ({ value: { scrollY } }) => {
      if (!ref.current) {
        return;
      }
      const posY = ref.current.getBoundingClientRect().top;
      const newOffset = scrollY - posY;
      set.start({
        offset: newOffset,
      });
    },
  });

  const Animated = animated(({ style, ...other }) => (
    <BenefitItem offset={style.offset} {...other} />
  ));

  return (
    <Section
      pt={{ md: 18.75 }}
      pb={{ md: 18.75 }}
      sectionSx={{ overflow: "hidden" }}
    >
      <Box
        sx={{
          height: { xs: "643px", md: "450px" },
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
        ref={ref}
      >
        <Box
          sx={{
            position: "relative",
            zIndex: "1",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              marginBottom: "16px",
              textAlign: { xs: "start", md: "center" },
            }}
          >
            Trackmate benefits at a glance
          </Typography>
          <Typography
            variant="subtitle1"
            component="p"
            color={theme.palette.grey[600]}
            sx={{
              marginBottom: "16px",
              textAlign: { xs: "start", md: "center" },
            }}
          >
            Explore the extensive benefits that Trackmate offers. Our platform enhances operational efficiency, 
            boosts safety and compliance, and delivers real-time insights and actionable data, empowering your 
            business every step of the way.
          </Typography>
        </Box>
        <Box
          sx={{
            position: { xs: "relative", md: "absolute" },
            zIndex: "2",
            left: "0px",
            top: "0px",
            width: "100%",
            height: { xs: "325px", md: "500px" },
          }}
        >
          {options.map((opt, index) => (
            <Animated key={index} style={style} {...opt} />
          ))}
        </Box>
      </Box>
    </Section>
  );
};

export default BenefitsSection;
